module.exports = __webpack_public_path__ + "static/media/LinkedIn.23d6cfa3.png";